import React, { useCallback, useEffect, useState } from 'react'

import { FormControlLabel, Switch } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import api from 'common/api'

const useStyles = makeStyles(() => ({
  checkBoxNoMargin: {
    '& input': {
      margin: 0,
    },
  },
}))

const RoleControl = ({ role, initialAssignmentState, onChange, onError, userTarget, isUserPermitted, externalAssigned }) => {
  const [isAssigned, setIsAssigned] = useState(initialAssignmentState)

  const { Title, Id } = role

  const classes = useStyles()

  useEffect(() => {
    if (externalAssigned) {
      setIsAssigned(true)
    }
  }, [externalAssigned])

  const toggleAssignment = useCallback(
    (isAssigned) => {
      const url = `/api/users/${userTarget.Id}/roles/${Id}`
      let promise
      setIsAssigned(isAssigned)
      if (isAssigned) {
        promise = api.put(url)
      } else {
        promise = api.delete(url)
      }
      promise.then(() => onChange(isAssigned, Id)).catch(() => {
        setIsAssigned(!isAssigned)
        onError()
      })
    },
    [onChange, Id, userTarget, onError],
  )
  return (
    <FormControlLabel
      disabled={!isUserPermitted}
      aria-label={`toggle ${Title} permissions`}
      onClick={(e) => e.stopPropagation()}
      classes={{ root: classes.checkBoxNoMargin }}
      control={
        <Switch
          onChange={(e) => {
            e.stopPropagation()
            toggleAssignment(!isAssigned)
          }}
          disableRipple={false}
          color="primary"
          checked={isAssigned}
          name={Id}
        />
      }
      label={Title}
    />
  )
}
RoleControl.propTypes = {
  role: PropTypes.object.isRequired,
  initialAssignmentState: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  userTarget: PropTypes.object.isRequired,
  isUserPermitted: PropTypes.bool.isRequired,
  externalAssigned: PropTypes.bool,
}

export default RoleControl
